function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($component, $helpers, String, dateObj) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'date-input-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        const errorMessage = $component.getAttribute(`error-message`);
        __jade_nodes = __jade_nodes.concat(h("input", {
          "attrs": {
            type: `text`,
            placeholder: dateObj ? $helpers.formatDate(dateObj) : ``,
          },
          "on": {
            focus: $helpers.focusedInput,
            blur: $helpers.blurredInput,
            change: $helpers.changedInput,
          },
          "class": {
            error: !!errorMessage
          },
        }));
        __jade_nodes = __jade_nodes.concat((errorMessage) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", [__vjadeSafeCode(errorMessage)]));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "dateObj" in locals ? locals.dateObj : typeof dateObj !== "undefined" ? dateObj : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;